import { API } from "../api";
import { DAILY_DELIVERY_REPORT } from "../constants/url.constant";
import { setError } from "./Indicator";

const REQUEST_TOTAL_ORDER_DELIVERED_COUNT =
  "REQUEST_TOTAL_ORDER_DELIVERED_COUNT";
const REQUEST_TOTAL_COD_AMOUNT_FOR_DELIVERED_ORDERS =
  "REQUEST_TOTAL_COD_AMOUNT_FOR_DELIVERED_ORDERS";
const REQUEST_TOTAL_AMOUNT_COLLECTED_BY_DA_FOR_DELIVERED_ORDERS =
  "REQUEST_TOTAL_AMOUNT_COLLECTED_BY_DA_FOR_DELIVERED_ORDERS";

const SET_TOTAL_ORDER_DELIVERED_COUNT = "SET_TOTAL_ORDER_DELIVERED_COUNT";
const SET_TOTAL_COD_AMOUNT_FOR_DELIVERED_ORDERS =
  "SET_TOTAL_COD_AMOUNT_FOR_DELIVERED_ORDERS";
const SET_TOTAL_AMOUNT_COLLECTED_BY_DA_FOR_DELIVERED_ORDERS =
  "SET_TOTAL_AMOUNT_COLLECTED_BY_DA_FOR_DELIVERED_ORDERS";

export const REQUEST_DAILY_DELIVERED_ORDERS = "REQUEST_DAILY_DELIVERED_ORDERS";
export const SET_DAILY_DELIVERED_ORDERS = "SET_DAILY_DELIVERED_ORDERS";

export const getDeliveryReportStatistics = (payload) => {
  return async (dispatch) => {
    if (payload.type === "TOTALORDER") {
      dispatch({ type: REQUEST_TOTAL_ORDER_DELIVERED_COUNT });
    } else if (payload.type === "CODAMOUNT") {
      dispatch({ type: REQUEST_TOTAL_COD_AMOUNT_FOR_DELIVERED_ORDERS });
    } else if (payload.type === "AMOUNTCOLLECTED") {
      dispatch({
        type: REQUEST_TOTAL_AMOUNT_COLLECTED_BY_DA_FOR_DELIVERED_ORDERS
      });
    }

    try {
      const res = await API.get(`${DAILY_DELIVERY_REPORT}/stats`, {
        params: payload
      });

      if (payload.type === "TOTALORDER") {
        dispatch({
          type: SET_TOTAL_ORDER_DELIVERED_COUNT,
          payload: res
        });
      } else if (payload.type === "CODAMOUNT") {
        dispatch({
          type: SET_TOTAL_COD_AMOUNT_FOR_DELIVERED_ORDERS,
          payload: res
        });
      } else if (payload.type === "AMOUNTCOLLECTED") {
        dispatch({
          type: SET_TOTAL_AMOUNT_COLLECTED_BY_DA_FOR_DELIVERED_ORDERS,
          payload: res
        });
      }

      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Somehing went wrong!"));
    }
  };
};

export const setDailyDeliveredOrders = (data) => {
  return {
    type: SET_DAILY_DELIVERED_ORDERS,
    payload: data
  };
};

export const getDailyDeliveredOrders = (payload) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_DAILY_DELIVERED_ORDERS });
    try {
      const res = await API.post(`${DAILY_DELIVERY_REPORT}`, payload);

      return dispatch(setDailyDeliveredOrders(res));
    } catch (error) {
      console.log(error);
      dispatch(setError("Somehing went wrong!"));
    }
  };
};

const initialState = {
  isLoading: false,
  loaded: false,
  columns: [],
  data: [],
  totalRows: 0,
  totalOrders: {
    value: 0,
    isLoading: true
  },
  totalCODAmount: {
    value: 0,
    isLoading: true
  },
  totalAmountCollected: {
    value: 0,
    isLoading: true
  }
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case REQUEST_DAILY_DELIVERED_ORDERS:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case SET_DAILY_DELIVERED_ORDERS:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        columns: payload.columns,
        rows: payload.rows,
        totalRows: payload.count
      };
    case REQUEST_TOTAL_ORDER_DELIVERED_COUNT:
      return {
        ...state,
        totalOrders: {
          isLoading: true
        }
      };
    case SET_TOTAL_ORDER_DELIVERED_COUNT:
      return {
        ...state,
        totalOrders: {
          isLoading: false,
          value: payload.totalOrders
        }
      };
    case REQUEST_TOTAL_COD_AMOUNT_FOR_DELIVERED_ORDERS:
      return {
        ...state,
        totalCODAmount: {
          isLoading: true
        }
      };
    case SET_TOTAL_COD_AMOUNT_FOR_DELIVERED_ORDERS:
      return {
        ...state,
        totalCODAmount: {
          isLoading: false,
          value: payload.totalCODAmount
        }
      };
    case REQUEST_TOTAL_AMOUNT_COLLECTED_BY_DA_FOR_DELIVERED_ORDERS:
      return {
        ...state,
        totalAmountCollected: {
          isLoading: true
        }
      };
    case SET_TOTAL_AMOUNT_COLLECTED_BY_DA_FOR_DELIVERED_ORDERS:
      return {
        ...state,
        totalAmountCollected: {
          isLoading: false,
          value: payload.totalAmountCollected
        }
      };
    default:
      return state;
  }
}
